import { Chip, IconButton, TableCell, TableRow } from "@mui/material";
import { capitalCase } from "change-case";
import Iconify from "src/components/Iconify";
import ParseDate from "src/components/date";
import Ternary from "src/components/ternary";
import Translate from "src/components/translate";

const DataList = ({ consultation, handleOpenMenu, rowNumber }) => {
  const {
    purchase_id,
    username,
    first_name,
    last_name,
    mobile,
    status,
    referral_username,
    purchase_date,
    product_type,
    name,
  } = consultation;

  return (
    <TableRow key={purchase_id}>
      <TableCell>{rowNumber}</TableCell>
      <TableCell>
        {first_name} {last_name}
      </TableCell>
      <TableCell>{username}</TableCell>
      <TableCell>{mobile}</TableCell>
      <TableCell>{referral_username}</TableCell>
      {/* <TableCell>{product_type || ""}</TableCell> */}
      <TableCell>{name || ""}</TableCell>
      <TableCell>
        <ParseDate date={purchase_date} />
      </TableCell>
      

      <TableCell>{capitalCase(status || "")}</TableCell>
      <TableCell>
        <IconButton
          onClick={handleOpenMenu(purchase_id, status)}
          name="more-button"
        >
          <Iconify icon={"eva:more-vertical-fill"} width={20} height={20} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default DataList;
